module.exports = __webpack_public_path__ + "img/luntanA_14.2c72cd68.jpg";